/**************************************************************************************************/
/*   File: /src/app/stores/states/dossiers/state.ts                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday February 20th 2019                                                   */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 07 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromShared from '../../../shared';

/**
 * The dossiers state
 */
export interface DossiersState {
  /**
   * The messages
   */
  messages: fromShared.models.Message[];
  /**
   * is loading
   */
  isLoading: boolean;
  /**
   * the dossiers
   */
  dossiers: fromShared.models.DossierSummary[];
}

/**
 * The initial dossiers state
 */
export const INITIAL_DOSSIERS_STATE: DossiersState = {
  messages: [],
  isLoading: false,
  dossiers: []
};

/**
 * The state name
 */
export const STATE_NAME = 'dossiers';